import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { OtpInputWrapper } from '../Otp/Otp.styles';
import { ResendText, TrustBadge, TrustGrid } from './Onboarding.styles';

export const AuthFormShell = styled.div`
  .auth-heading {
    h1 {
      font-size: 32px;
      font-weight: 600;
      line-height: 1.05;
      letter-spacing: -0.025em;
      color: var(--text-color-50);
      text-wrap: balance;
      text-transform: none;
      margin: 0 0 16px;
      
      @media (min-width: 640px) {
        font-size: 40px;
      }
    }
    
    p {
      max-width: 400px;
      font-size: 15px;
      line-height: 1.625;
      color: var(--text-color);
      margin: 0 0 16px; 
    }

    .gradient-text {
      background-image: var(--onboarding-brand-gradient);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;
    }
  }

  form {
    margin-top: 36px;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  label,
  .label-text {
    font-size: 13px !important;
    font-weight: 500 !important;
    color: var(--text-color-50) !important;
    margin-bottom: 6px !important;
  }

  input[type='text'],
  input[type='email'],
  input[type='password'] {
    height: 48px !important;
    border-radius: 12px !important;
    border: 1px solid var(--gray-350) !important;
    font-size: 15px !important;
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .text-box {
    margin: 4px 0 8px;
  }

  .privacy {
    font-size: 12px;
    line-height: 1.5;
    color: var(--text-color);
    text-align: center;

    a {
      font-weight: 500;
      color: var(--text-color-50);
      text-decoration: underline;
      text-underline-offset: 2px;
    }
  }

  .forget-password {
    display: block;
    margin: -4px 0 8px;
    text-align: right;
    font-size: 13px;
    font-weight: 500;
    color: var(--blue);
  }

  .btn-holder {
    margin-top: 8px;

    /* button {
      border-radius: 12px !important;
      background-image: var(--onboarding-brand-gradient) !important;
      font-size: 15px !important;
      font-weight: 600 !important;
      color: var(--white) !important;
      box-shadow: var(--onboarding-shadow-elevated);
    } */
  }

  .seprator {
    position: relative;
    padding: 4px 0;
    margin: 12px 0;

    .text {
      position: relative;
      display: flex;
      justify-content: center;
      background: var(--white);
      padding: 0 12px;
      margin: 0 auto;
      width: fit-content;
      font-size: 11px;
      text-transform: uppercase;
      letter-spacing: 0.14em;
      color: var(--text-color);

      &::before,
      &::after {
        display: none;
      }
    }

    &::before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 50%;
      border-top: 1px solid var(--gray-350);
    }
  }

  .googleAuth {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    height: 48px;
    margin-bottom: 0;
    padding: 0 16px;
    border: 1px solid var(--gray-350);
    border-radius: 12px;
    background: var(--white);
    font-weight: 500;
    font-size: 14px;
    color: var(--text-color-50);
    transition: background 0.2s ease;

    &:hover:not(:disabled) {
      background: var(--gray-100);
      color: var(--text-color-50);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    .img-holder {
      font-size: 16px;
      line-height: 1;
    }
  }

  ${OtpInputWrapper} {
    width: 100%;
    max-width: 280px;
    margin: 0 auto 16px;

    .otp-fields {
      justify-content: center;
      gap: 12px;
      margin-bottom: 16px;
    }

    input {
      width: 56px !important;
      min-width: 56px !important;
      max-width: 56px !important;
      height: 56px !important;
      padding: 0 !important;
      border-radius: 12px !important;
      border: 1px solid var(--gray-350) !important;
      background: var(--white) !important;
      font-size: 24px !important;
      font-weight: 600 !important;
      line-height: 1 !important;
      color: var(--text-color-50) !important;
      box-shadow: var(--onboarding-shadow-soft) !important;
      -moz-appearance: textfield;
      appearance: textfield;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      &::placeholder {
        font-size: 18px !important;
        font-weight: 500 !important;
        line-height: 1 !important;
        color: #777777 !important;
      }

      &:focus {
        outline: none;
      }

      &:focus,
      &:not(:placeholder-shown) {
        border-color: var(--green-50) !important;
        box-shadow: 0 0 0 2px rgba(13, 160, 106, 0.35) !important;
      }

      &.error {
        border-color: var(--danger) !important;
        box-shadow: none !important;
      }
    }

    .timer {
      font-size: 14px;
      color: var(--text-color);

      .resend-code {
        color: var(--text-color);

        &:not(.disabled) {
          color: var(--blue);
        }

        &.disabled {
          color: var(--gray-300);
        }
      }

      .time-left {
        color: var(--text-color-50);
        font-weight: 500;
      }
    }
  }

  ${({ $centered }) =>
    $centered &&
    css`
      text-align: center;

      .auth-heading {
        width: 100%;

        h1 {
          text-align: center;
        }

        p {
          margin: 0 auto 16px;
          text-align: center;
        }
      }

      ${ResendText} {
        text-align: center;
      }

      ${TrustGrid} {
        width: 100%;
      }

      ${TrustBadge} {
        flex-direction: column;
        text-align: center;
        gap: 6px;
      }
    `}
`;

export const AuthFooterLink = styled.p`
  margin-top: 24px;
  text-align: center;
  font-size: 14px;
  color: var(--text-color);

  @media (min-width: 640px) {
    display: none;
  }

  a {
    font-weight: 500;
    color: var(--text-color-50);

    &:hover {
      color: var(--blue);
    }
  }
`;

export const AuthForgotLink = styled(Link)`
  display: block;
  margin: -4px 0 8px;
  text-align: right;
  font-size: 13px;
  font-weight: 500;
  color: var(--blue);
`;
